// src/components/Shared/ProfileRow.jsx
import React from 'react';
import { Box, Typography, Paper, Fade } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const ProfileRow = ({ profile, selected, onSelect }) => {
  const { name, description } = profile;

  return (
    <Paper
      variant="outlined"
      onClick={onSelect}
      sx={(theme) => ({
        p: 2,
        mb: 1.5,
        borderRadius: 3, // Rounder corners for a modern feel
        cursor: 'pointer',
        position: 'relative',
        overflow: 'hidden',

        // Border & Background Logic
        borderColor: selected ? 'success.main' : 'divider',
        borderWidth: selected ? 2 : 1,
        bgcolor: selected ? 'success.lighter' : 'background.paper',
        
        // Polished Transitions
        transition: theme.transitions.create(
          ['box-shadow', 'border-color', 'background-color', 'transform'],
          { duration: theme.transitions.duration.shorter }
        ),

        '&:hover': {
          transform: 'translateY(-2px)',
          borderColor: selected ? 'success.main' : 'primary.light',
          boxShadow: theme.shadows[3],
          bgcolor: selected ? 'success.lighter' : 'action.hover',
        },

        '&:active': {
          transform: 'translateY(0)',
        },

        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: 2,
      })}
    >
      <Box sx={{ minWidth: 0, flex: 1 }}>
        <Typography 
          variant="subtitle1" 
          sx={{ 
            fontWeight: 700, 
            color: selected ? 'success.dark' : 'text.primary',
            lineHeight: 1.2
          }} 
          noWrap
        >
          {name}
        </Typography>

        {description && (
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{
              mt: 0.5,
              display: '-webkit-box',
              WebkitLineClamp: 2,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
              fontSize: '0.8rem',
              opacity: 0.8
            }}
          >
            {description}
          </Typography>
        )}
      </Box>

      {/* Visual Feedback for Selection */}
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        {selected ? (
          <Fade in={selected}>
            <CheckCircleIcon color="success" fontSize="medium" />
          </Fade>
        ) : (
          <Box 
            sx={{ 
              width: 20, 
              height: 20, 
              borderRadius: '50%', 
              border: '2px solid', 
              borderColor: 'divider',
              opacity: 0.5
            }} 
          />
        )}
      </Box>
    </Paper>
  );
};

export default ProfileRow;